@let typeValue = type();
@let messageValue = message();
@if (
  typeValue === 'NOWARN' ||
  typeValue === 'ENTWARN' ||
  typeValue === 'AUTOENTWARN'
) {
  {{ messageValue | translate }}
} @else {
  {{ messageValue }}
}
